import { useCallback, useEffect, useRef } from "react";
import "../styles/modal.css";

const Modal = (props) => {
  const { isOpen, onClose, Content, styleOverlay, styleContent } = props;
  const modalRef = useRef();

  // Close the modal if the user clicks outside the modal content
  const handleOutsideClick = useCallback(
    (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen) {
      // Use mousedown instead of click and delay to avoid immediate closure
      const timer = setTimeout(() => {
        document.addEventListener("mousedown", handleOutsideClick);
      }, 100);

      return () => {
        clearTimeout(timer);
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [isOpen, handleOutsideClick]);

  return (
    <div>
      {isOpen && (
        <div className="modal-overlay" style={styleOverlay}>
          <div className="modal-content" style={styleContent} ref={modalRef}>
            <span className="close" onClick={onClose}>
              &times;
            </span>
            <Content />
          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;
